import { ICssShadow } from './../ICssShadow.interface';
import { SeCommonConfig } from './../SeCommonConfig.class';
import { IBaseSEConfig } from '../base-se-config.interface';
import * as _ from 'lodash';

export class SeTextboxConfig extends SeCommonConfig implements IBaseSEConfig {

  // settings just for this element
  public SeType = 'SeTextbox';
  public text = '';
  public html = '';
  public fontSize = 10;
  public fontFamily = 'Helvetica';
  public backgroundColor = null;
  public fontColor = '#1c2b36';
  public htmlMode = true;
  public textShadows: Array<ICssShadow> = new Array<ICssShadow>();

  constructor(jsonString?: string) {
    super();
    if (jsonString) {
      this.fromJsonString(jsonString);
    }
  }

  // create json from class vars
  toJson() {
    const obj = super.toJson(); // process common base config settings
    obj.SeType = this.SeType;
    obj.backgroundColor = this.backgroundColor;
    obj.text = this.text; // and any custom props
    obj.html = this.html;
    obj.fontSize = this.fontSize;
    obj.fontColor = this.fontColor;
    obj.fontFamily = this.fontFamily;
    obj.htmlMode = this.htmlMode;
    obj.textShadows = this.textShadows;

    obj.fonts = [];
    if (obj.fontFamily) {
      obj.fonts.push({ source: 'google', fontName: this.fontFamily });
    }

    return obj;
  }

  // parse json to class vars
  fromJson(obj) {
    super.fromJson(obj); // process common base config settings
    this.backgroundColor = _.get(obj, 'backgroundColor', null);
    this.SeType = _.get(obj, 'SeType', 'SeTextbox');
    this.text = _.get(obj, 'text', ''); // get val in safe way with defalut
    this.html = _.get(obj, 'html', ''); // get val in safe way with defalut
    this.fontSize = _.get(obj, 'fontSize', 10);
    this.fontColor = _.get(obj, 'fontColor', '#1c2b36');
    this.fontFamily = _.get(obj, 'fontFamily', 'Helvetica');
    this.htmlMode = _.get(obj, 'htmlMode', true);
    this.textShadows = _.get(obj, 'textShadows', new Array<ICssShadow>());

    // override super vars here
    this.fonts = [];
    if (this.fontFamily) {
      this.fonts.push({ source: 'google', fontName: this.fontFamily });
    }

  }

  toJsonString() {
    return JSON.stringify(this.toJson());
  }

  fromJsonString(str) {
    this.fromJson(JSON.parse(str));
  }


}



// WEBPACK FOOTER //
// ./src/app/backend-main.module/pages/designer.module/screen-elements.module/se-textbox/se-textbox-config.class.ts